import { createFileRoute } from "@tanstack/react-router";
import { PostEditor } from "@/components/blog/PostEditor";

export const Route = createFileRoute("/_authenticated/admin/posts/new")({
  head: () => ({ meta: [{ title: "New post — Admin" }, { name: "robots", content: "noindex" }] }),
  component: NewPost,
});

function NewPost() {
  return (
    <div>
      <h2 className="h-display mt-8 text-2xl text-bone">New post</h2>
      <PostEditor />
    </div>
  );
}
